export default __webpack_public_path__ + "static/media/Completed.c97dbb93.svg";